module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-583-retro.37c551fc.jpg";